import {Injectable} from '@angular/core';
import {CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {GlobalService} from '../service/global.service';
import {Observable, Subject} from 'rxjs/Rx';

@Injectable()
export class LoginGuard implements CanActivate {

    constructor(protected router: Router, protected globalService: GlobalService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        if (state.url !== '/login' && (!this.globalService.estaAutenticado() || this.globalService.tokenExpirado())) {
            this.router.navigate(['/login']);
            return false;
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/login-guard.ts